export const svgIcons: string[] = [
    'aml-energy-logo',
    'usdt-icon',
    'btc-icon',
    'eth-icon',
    'trx-icon',
    'sol-icon',
    'usdc-icon',
    'dai-icon',
    'usdd-icon',
    'bnb-icon',
    'sol-color',
    'usdc-color',
    'dai-color',
    'shield',
    'tooltip-icon',
    'circle-usdt',
    'users',
    'download',
    'logout',
    'edit',
    'wallet',
    'copy-clipboard',
    'download-icon',
    'back',
    'choose',
    'wallet_type_cold',
    'wallet_type_exchange',
    'close',
    'risk-low',
    'risk-medium',
    'risk-high',
    'risk-severe',
    'lea-report-closed',
    'lea-report-permantn-closed',
    'incident-progress-next',
    'incident-progress-current',
    'incident-progress-success',
    'white-round-success',
    'clock-two',
    'slim-nav-arrow',
    'check-green',
    'slim-arrow-down',
    'slim-arrow-up',
    'beosin',
    'bitok',
    'global-ledger',
    'secret-sauce',
    'btc',
    'eth',
    'trx',
    'usdt',
    'usdc',
    'dai',
    'bnb',
    'sol',
    'usdd',
    'btc-network',
    'eth-network',
    'trx-network',
    'sol-network',
    'bsc-network',
    'bep-20',
    'erc-20',
    'trc-20',
    'ltc',
    'arrow-down-new',
    'arrow-up-new',
    'report-incoming',
    'report-outgoing',
    'teather-icon',
    'markup-filter'
];
